<!-- fieldAwesome.vue -->
<template>
    <div>
            <div v-if="!schema.disableCheckbox" class="checkbox">
                <label>
                    <input v-model="parent" type="checkbox"> {{schema.checkboxLabel}}
                </label>
            </div>
            <input v-if="!parent"
                    class="form-control input-text"
                    type="text"
                    v-model="price"
                    :disabled="parent"
                    :maxlength="schema.max"
                    :placeholder="schema.placeholder"
                    :readonly="schema.readonly" >
            <span v-if="!parent" class="unit-text">{{schema.unitText}}</span>
    </div>
</template>

<script>
    import { abstractField } from 'vue-form-generator'

    export default {
        mixins: [ abstractField ],
        data () {
            return {
                parent: false,
                price: 0.1,
                ignoreNextChange: false
            }
        },
        watch: {
            value (value) {
                if (this.ignoreNextChange) {
                    this.ignoreNextChange = false
                    return
                }
                this.parsePrice(value)
            },
            parent (value) {
                // this.ignoreNextChange = true
                this.value = this.parent + '-' + this.price
            },
            price (value) {
                // this.ignoreNextChange = true
                this.value = this.parent + '-' + this.price
            }
        },
        methods: {
            parsePrice (price) {
                const data = price.split('-')
                this.parent = data[0] === 'true'
                this.price = data[1]
            }
        },
        created () {
            if (this.value) {
                this.parsePrice(this.value)
            }
        }
    }
</script>

<style scoped>
    .input-text {
        width: 200px !important;
        display: inline-block;
        vertical-align: middle;
    }
    .unit-text {
        margin-left: 8px;
        vertical-align: middle;
    }
    .input-text:disabled {
        background-color: #eee;
    }
</style>
